import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MyChartersCardComponent } from './my-charters-card.component';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { ChickenTestDialogModule } from '../dialogs/chicken-test-dialog/chicken-test-dialog.module';
import { LoadingModule } from '../loading/loading.module';

@NgModule({
  declarations: [MyChartersCardComponent],
  imports: [
    CommonModule,
    MatCardModule,
    MatButtonModule,
    ChickenTestDialogModule,
    LoadingModule,
  ],
  exports: [MyChartersCardComponent],
})
export class MyChartersCardModule {}
